<template>
    <div class="flex">
        <div>
            <div :class="{'label-input-select main-text-color': edit }" class="description-field label-input">{{ $t('general.gmtType') }}</div>
            <el-select :placeholder="$t('general.sortBy')" v-model="gmtOffsetType" size="small" class="select-type">
                <el-option :key="option.value" v-bind="option" v-for="option in gmtOffsetTypes"/>
            </el-select>
        </div>
        <div v-if="gmtOffsetType === GmtOffsetTypes.Account" class="select-field">
            <div :class="{'label-input-select main-text-color': edit }" class="description-field">{{ $t('general.account') }}</div>
            <el-select :placeholder="$t('general.account')" v-model="account" size="small" class="select-type">
                <el-option :key="option.AccountID" :value="option.AccountID" :label="option.dist_name" v-bind="option" v-for="option in allAccounts"/>
            </el-select>
        </div>
        <div v-if="gmtOffsetType === GmtOffsetTypes.DashboardTimezone" class="select-field">
            <div :class="{'label-input-select main-text-color': edit }" class="description-field">{{ $t('general.timezone') }}</div>
            <el-select :placeholder="$t('general.timezone')" filterable v-model="gmtOffsetNumber" size="small" class="select-type">
                <el-option :key="option.value" :value="option.value" :label="option.label" v-bind="option" v-for="option in timezones"/>
            </el-select>
        </div>
    </div>
</template>
<script>
    import { Option, Select} from 'element-ui'
    import momentTimezone from 'moment-timezone'
    import {GmtOffsetTypes} from '@/enum/gmt'

    export default {
        name: 'gmt-offset',
        props: {
            value: {
                required: true
            },
            edit: {
                type: Boolean,
                default: false
            }
        },
        components: {
            [Select.name]: Select,
            [Option.name]: Option
        },
        data() {
            return {
                GmtOffsetTypes,
                gmtOffsetTypes: [
                    { label: this.$t('general.account'), value: GmtOffsetTypes.Account  },
                    { label: this.$t('general.browser'), value:  GmtOffsetTypes.Browser },
                    { label: this.$t('general.dashboardConf'), value:  GmtOffsetTypes.DashboardTimezone }
                ],
                gmtOffsetType: GmtOffsetTypes.Browser,
                account: null,
                gmtOffsetNumber: null
            }
        },
        computed: {
            allAccounts () {
                const accounts = this.$store.getters['entities/getEntityList']('Accounts')
                return accounts
            },
            GMTOffsetData () {
                const data = {
                    Type: this.gmtOffsetType
                }
                if (this.gmtOffsetType === this.GmtOffsetTypes.Browser) {
                    this.account = null
                    this.gmtOffsetNumber = null
                    if ('AccountID'in data) {
                        delete data.AccountID
                    }
                    if ('GMTOffset'in data) {
                        delete data.GMTOffset
                    }
                }
                if (this.gmtOffsetType === this.GmtOffsetTypes.Account) {
                    data.AccountID = this.account
                }
                if (this.gmtOffsetType === this.GmtOffsetTypes.DashboardTimezone) {
                    data.GMTOffset = this.gmtOffsetNumber
                }
                return data
            },
            timezones () {
                const timeZones = momentTimezone.tz.names();
                const offsetTmz=[];

                for(const i in timeZones) {
                    offsetTmz.push({
                        value: timeZones[i],
                        label: " (GMT"+momentTimezone.tz(timeZones[i]).format('Z')+") " + timeZones[i]
                    });
                }

                return offsetTmz
            },
            typeOfError () {
                if (this.GMTOffsetData.Type === this.GmtOffsetTypes.Account && this.GMTOffsetData.AccountID === null) {
                    return this.$t('general.account')
                }
                if (this.GMTOffsetData.Type === this.GmtOffsetTypes.DashboardTimezone && this.GMTOffsetData.GMTOffset === null) {
                    return this.$t('general.timezone')
                }

                return ''
            }
        },
        async mounted() {
            if (this.value && Object.keys(this.value).length) {
                this.gmtOffsetType = this.value.Type
                if (this.gmtOffsetType === this.GmtOffsetTypes.Account) {
                    this.account = this.value.AccountID
                }
                if (this.gmtOffsetType === this.GmtOffsetTypes.DashboardTimezone) {
                    this.gmtOffsetNumber = this.value.GMTOffset
                }
            }
        },
        watch: {
            GMTOffsetData: {
                handler (val) {
                    if (val) {
                        this.$emit('update:value', val)
                        this.$emit('update:error', this.typeOfError)
                    }
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>

<style>
[dir="ltr"] .description-field {
    margin-right: 10px;
}
[dir="rtl"] .description-field {
    margin-left: 10px;
}
[dir="ltr"] .select-field {
    margin-left: 20px;
}
[dir="rtl"] .select-field {
    margin-right: 20px;
}
.label-input-select {
    @apply flex text-main-sm font-medium truncate mb-3;
}
</style>
